import { ApiService } from './api';
import {
  BannerResponse,
  CreateBannerRequest,
  UpdateBannerRequest,
  UpdateBannerPriorityRequest,
} from '../types/banner';
import { ApiResponse } from '../types/auth';

class BannerService {
  private apiService: ApiService;

  constructor() {
    this.apiService = ApiService.getInstance();
  }

  async getAllBanners(): Promise<ApiResponse<BannerResponse[]>> {
    try {
      const data = await this.apiService.get<BannerResponse[]>('/admin/banners');
      return { success: true, data };
    } catch (error: any) {
      return {
        success: false,
        error: error.message || 'Failed to fetch banners',
      };
    }
  }

  async getBannerById(bannerId: number): Promise<ApiResponse<BannerResponse>> {
    try {
      const data = await this.apiService.get<BannerResponse>(`/admin/banners/${bannerId}`);
      return { success: true, data };
    } catch (error: any) {
      return {
        success: false,
        error: error.message || 'Failed to fetch banner',
      };
    }
  }

  async createBanner(request: CreateBannerRequest): Promise<ApiResponse<BannerResponse>> {
    try {
      const data = await this.apiService.post<BannerResponse>('/admin/banners', request);
      return { success: true, data };
    } catch (error: any) {
      return {
        success: false,
        error: error.message || 'Failed to create banner',
      };
    }
  }

  async updateBanner(
    bannerId: number,
    request: UpdateBannerRequest
  ): Promise<ApiResponse<BannerResponse>> {
    try {
      const data = await this.apiService.put<BannerResponse>(`/admin/banners/${bannerId}`, request);
      return { success: true, data };
    } catch (error: any) {
      return {
        success: false,
        error: error.message || 'Failed to update banner',
      };
    }
  }

  async updateBannerPriorities(request: UpdateBannerPriorityRequest): Promise<ApiResponse<void>> {
    try {
      await this.apiService.patch<void>('/admin/banners/priorities', request);
      return { success: true };
    } catch (error: any) {
      return {
        success: false,
        error: error.message || 'Failed to update banner priorities',
      };
    }
  }

  async deleteBanner(bannerId: number): Promise<ApiResponse<void>> {
    try {
      await this.apiService.delete<void>(`/admin/banners/${bannerId}`);
      return { success: true };
    } catch (error: any) {
      return {
        success: false,
        error: error.message || 'Failed to delete banner',
      };
    }
  }
}

export const bannerService = new BannerService();
